import { render } from "./JoinUsJoiningRequirements.vue?vue&type=template&id=968bebdc"
const script = {}

import exportComponent from "/home/fluffypony/Projects/tai-g-damn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__